export const KANBAN_DATE_GROUPING_KEYS = new Set([
  'day_of_week',
  'day-of-week',
  'hour_of_day',
  'hour-of-day',
  'month_of_year',
  'month-of-year',
])

export const isKanbanDateGroupingKey = (
  groupingKey: string | undefined,
): boolean => KANBAN_DATE_GROUPING_KEYS.has((groupingKey || '').toLowerCase())

export type KanbanGroupConfigLike = {
  field: string
  groupingKey?: string
  options?: Array<{ value: string; label: string }> | null
}

export type KanbanExpansionField = {
  handle: string
  modelId?: string
  relationshipLink?: unknown | null
  definition?: { options?: Array<{ value: string; label: string }> | null } | null
}

/**
 * Whether a kanban section/subsection can expand into real columns.
 * Date grouping keys always expand. Enum/select needs live definition options
 * or a persisted options overlay. Relation grouping needs persisted options.
 */
export const canExpandKanbanGroup = (args: {
  group: KanbanGroupConfigLike
  fields: KanbanExpansionField[]
  modelId?: string
}): boolean => {
  const { group, fields, modelId } = args
  if (!group.field) {
    return false
  }
  if (isKanbanDateGroupingKey(group.groupingKey)) {
    return true
  }

  const persistedOptions = Array.isArray(group.options) ? group.options : []
  if (persistedOptions.length > 0) {
    return true
  }

  const field = fields.find(
    (entry) =>
      entry.handle === group.field &&
      (!modelId || !entry.modelId || entry.modelId === modelId),
  )
  const definitionOptions = field?.definition?.options ?? []
  return definitionOptions.length > 0
}
